function defaultSkipElementChildren(element) {
  return element.tagName.toLowerCase() === "svg";
}
export {
  defaultSkipElementChildren
};
//# sourceMappingURL=defaultSkipElementChildren.js.map
